import {
  PeopleOutline,
  Event,
  LocationOn,
  Settings,
  MeetingRoomOutlined,
  NotificationsActiveOutlined,
  CasesOutlined,
  ImageOutlined,
  ShieldOutlined,
  MilitaryTech,
  Group,
  HowToVote,
  ForumOutlined,
  HowToReg,
  Badge,
  MailOutline
} from '@material-ui/icons'
import Events from 'views/admin/events/Events'
import Speakers from 'views/admin/speakers/Speakers'
import Sponsors from 'views/admin/sponsors/Sponsors'
import Attendees from 'views/admin/attendees/Attendees'
import Venue from 'views/admin/venue/Venue'
import Config from 'views/admin/configuration/Config'
import Conference from 'views/admin/conference/Conference'
import Announcements from 'views/admin/announcements/Announcements'
import EventCards from 'views/admin/eventCards/EventCards'
import Vendors from 'views/admin/vendors/Vendors'
import Moderators from 'views/admin/moderators/Moderators'
import SponsorshipLevels from 'views/admin/sponsorshipLevels/SponsorshipLevels'
import Admins from 'views/admin/conf-admins/Admins'
import { Roles } from 'constants/index'
import MyConference from 'views/admin/conference/MyConference'
import Subjects from 'views/admin/subjects/Subjects'
import Polls from 'views/admin/polling/Polls'
import TalksPage from 'views/admin/talks/Talk'
import ConferenceSettings from 'views/admin/settings/Settings'
import Attendance from 'views/admin/attendance/Attendance'
import Badges from 'views/admin/Badges/Badges'
import DefaultEmailTemplates from 'views/admin/DefaultEmailTemplates/DefaultEmailTemplates'

const basePath = '/admin'

export const getConsoleHome = (user) => {
  if (user.role === Roles.SUPER_ADMIN) return `${basePath}/conferences`
  else return `${basePath}/conference/${user.conferenceId}`
}

export const getRoutesBasedOnRole = (role) => {
  if (role === Roles.SUPER_ADMIN) return SuperAdminRoutes
  else return AdminRoutes
}

export const SuperAdminRoutes = [
  {
    name: 'Conferences',
    icon: MeetingRoomOutlined,
    path: `${basePath}/conferences`,
    component: Conference
  },
  {
    name: 'Conference Admins',
    icon: Group,
    path: `${basePath}/conference-admins`,
    component: Admins
  },
  {
    name: 'Attendees',
    icon: PeopleOutline,
    path: `${basePath}/attendees`,
    component: Attendees
  },
  {
    name: 'Subject Invites',
    icon: Group,
    path: `${basePath}/subjects`,
    component: Subjects
  },
  {
    name: 'Polls',
    icon: HowToVote,
    path: `${basePath}/polls`,
    component: Polls
  },
  {
    name: 'Education Credits',
    icon: HowToReg,
    path: `${basePath}/education-credits`,
    component: Attendance
  },
  {
    name: 'Email Templates',
    icon: MailOutline,
    path: `${basePath}/email-templates`,
    component: DefaultEmailTemplates
  },
  {
    name: 'App Settings',
    icon: Settings,
    path: `${basePath}/settings`,
    component: Config
  }
]

export const AdminRoutes = [
  {
    name: 'Conference',
    icon: MeetingRoomOutlined,
    path: `${basePath}/conference`,
    component: MyConference
  },
  {
    name: 'Events',
    icon: Event,
    path: `${basePath}/events`,
    component: Events
  },
  {
    name: 'Venues',
    icon: LocationOn,
    path: `${basePath}/venue`,
    component: Venue
  },
  {
    name: 'Subject Invites',
    icon: Group,
    path: `${basePath}/subjects`,
    component: Subjects
  },
  {
    name: 'Speakers',
    icon: PeopleOutline,
    path: `${basePath}/speakers`,
    component: Speakers
  },
  {
    name: 'Moderators',
    icon: ShieldOutlined,
    path: `${basePath}/moderators`,
    component: Moderators
  },
  {
    name: 'Talks',
    icon: ForumOutlined,
    path: `${basePath}/talks`,
    component: TalksPage
  },
  {
    name: 'Polls',
    icon: HowToVote,
    path: `${basePath}/polls`,
    component: Polls
  },
  {
    name: 'Exhibitors',
    icon: CasesOutlined,
    path: `${basePath}/exhibitors`,
    component: Vendors
  },
  {
    name: 'Sponsors',
    icon: PeopleOutline,
    path: `${basePath}/sponsors`,
    component: Sponsors
  },
  {
    name: 'Sponsorship Level',
    icon: MilitaryTech,
    path: `${basePath}/sponsor-ship-level`,
    component: SponsorshipLevels
  },
  {
    name: 'Announcements',
    icon: NotificationsActiveOutlined,
    path: `${basePath}/announcements`,
    component: Announcements
  },
  {
    name: 'Card Color',
    icon: ImageOutlined,
    path: `${basePath}/eventCard`,
    component: EventCards
  },
  {
    name: 'Attendees',
    icon: PeopleOutline,
    path: `${basePath}/attendees`,
    component: Attendees
  },
  {
    name: 'Education Credits',
    icon: HowToReg,
    path: `${basePath}/education-credits`,
    component: Attendance
  },
  {
    name: 'Badge Printing',
    icon: Badge,
    path: `${basePath}/badge-printing`,
    component: Badges
  },
  {
    name: 'Settings',
    icon: Settings,
    path: `${basePath}/settings`,
    component: ConferenceSettings
  }
]
